var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(_vm.loading)?_c('Loading'):[_c('Header'),_c('router-view'),_c('Footer'),_c('FixedApps'),_c('CookieBanner')]],2)}
var staticRenderFns = []

export { render, staticRenderFns }